import * as type from '../../../actions/index.types';

const initialState = {
    rolesLoading: false,
    rolesData: null,
    rolesPagination: null,

    detailsLoading: false,
    detailsData: null,

    catalogLoading: false,
    catalogData: null,

    createLoading: false,
    updateLoading: false,
    setPermsLoading: false,
    deactivateLoading: false,

    error: null,
};

export function CtrlSystemRoleReducer(state = initialState, action) {
    switch (action.type) {
        // ---- roles list ----
        case type.CTRL_SYS_ROLE_LIST:
            return { ...state, rolesLoading: true, error: null };
        case type.CTRL_SYS_ROLE_LIST_SUCCESS: {
            const rows = action.payload?.rows;
            return {
                ...state,
                rolesLoading: false,
                rolesData: Array.isArray(rows) ? rows : [],
                rolesPagination: action.payload?.pagination || null,
            };
        }
        case type.CTRL_SYS_ROLE_LIST_FAILURE:
            return { ...state, rolesLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- role details (with permissions) ----
        case type.CTRL_SYS_ROLE_DETAILS:
            return { ...state, detailsLoading: true, detailsData: null, error: null };
        case type.CTRL_SYS_ROLE_DETAILS_SUCCESS:
            return { ...state, detailsLoading: false, detailsData: action.payload };
        case type.CTRL_SYS_ROLE_DETAILS_FAILURE:
            return { ...state, detailsLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- permission catalog (flat) ----
        case type.CTRL_SYS_PERMISSION_CATALOG:
            return { ...state, catalogLoading: true, error: null };
        case type.CTRL_SYS_PERMISSION_CATALOG_SUCCESS:
            return {
                ...state,
                catalogLoading: false,
                catalogData: Array.isArray(action.payload) ? action.payload : (action.payload?.data || []),
            };
        case type.CTRL_SYS_PERMISSION_CATALOG_FAILURE:
            return { ...state, catalogLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- create ----
        case type.CTRL_SYS_ROLE_CREATE:
            return { ...state, createLoading: true, error: null };
        case type.CTRL_SYS_ROLE_CREATE_SUCCESS:
            return { ...state, createLoading: false };
        case type.CTRL_SYS_ROLE_CREATE_FAILURE:
            return { ...state, createLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- update ----
        case type.CTRL_SYS_ROLE_UPDATE:
            return { ...state, updateLoading: true, error: null };
        case type.CTRL_SYS_ROLE_UPDATE_SUCCESS:
            return { ...state, updateLoading: false };
        case type.CTRL_SYS_ROLE_UPDATE_FAILURE:
            return { ...state, updateLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- set permissions ----
        case type.CTRL_SYS_ROLE_SET_PERMISSIONS:
            return { ...state, setPermsLoading: true, error: null };
        case type.CTRL_SYS_ROLE_SET_PERMISSIONS_SUCCESS:
            return { ...state, setPermsLoading: false };
        case type.CTRL_SYS_ROLE_SET_PERMISSIONS_FAILURE:
            return { ...state, setPermsLoading: false, error: action?.message || 'Something went wrong.' };

        // ---- deactivate ----
        case type.CTRL_SYS_ROLE_DEACTIVATE:
            return { ...state, deactivateLoading: true, error: null };
        case type.CTRL_SYS_ROLE_DEACTIVATE_SUCCESS:
            return { ...state, deactivateLoading: false };
        case type.CTRL_SYS_ROLE_DEACTIVATE_FAILURE:
            return { ...state, deactivateLoading: false, error: action?.message || 'Something went wrong.' };

        default:
            return state;
    }
}
